<template>
  <div>
    <b-row>
      <b-col md="12">
        <form-group :validations="validation">
          <div slot-scope="{ errors, invalid }">
            <div class="form-group">
              <label>{{ label }}</label>
              <input type="text" :value="inputValue.name" @input="updateValue" :class="{invalid}" class="form-control">
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-col>
    </b-row>

    <b-row class="mt-2 align-items-center">
      <b-col class="col-12">
        <div class="name-link-row">
          <router-link dir="ltr" :to="routerLink">/{{ inputValue.link }}</router-link>
          <b-icon icon="pencil" class="ml-3" v-b-toggle.edit-link></b-icon>
        </div>
        <b-collapse id="edit-link" class="mt-2">
          <input type="text" :value="inputValue.link" @input="updateLinkValue" class="form-control">
        </b-collapse>
      </b-col>
    </b-row>

    <b-row class="mt-3 align-items-center">
      <slot></slot>
    </b-row>
  </div>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";

export default {
  name: "NameAndLinkManager",
  props: ["validation", "label", "inputValue", 'routerLink'],
  components: {FormGroup, FormErrorsManager},
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  methods: {
    convertNameToLink(text, type) {
      let link = text.toLowerCase();
      link = link.replace(/ +/g, "-");
      link = link.replace(/[^\wآابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+/g, "-");
      if (
          (type === "link" && this.isItInUpdateMode()) ||
          !this.isItInUpdateMode()
      ) {
        this.inputValue.link = link;
      }
    },
    isItInUpdateMode() {
      return this.$route.params.link !== undefined;
    },
    updateValue(event) {
      let Value = event.target.value;
      if(this.$route.params.slug === undefined){
        this.convertNameToLink(Value)
      }
      this.inputValue.name = Value;
    },
    updateLinkValue(event) {
      let Value = event.target.value;
      this.convertNameToLink(Value)
    }
  },
};
</script>

<style scoped>
.name-link-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
}
</style>
